// import { closeMessage } from "./messages";

// export default function MessageList({ messages, onRefresh }) {
//   const close = async (id) => {
//     await closeMessage(id);
//     onRefresh();
//   };

//   return (
//     <div>
//       <h2>Active Messages</h2>

//       {messages?.map((m) => (
//         <div
//           key={m?.id}
//           style={{
//             border: "1px solid #ccc",
//             margin: 10,
//             padding: 10,
//           }}
//         >
//           <h3>{m?.title}</h3>
//           <p>{m?.message}</p>
//           <small>Type: {m?.type}</small>

//           <br />

//           <button onClick={() => close(m?.id)}>Close</button>
//         </div>
//       ))}
//     </div>
//   );
// }

import { closeMessage } from "./messages";

export default function MessageList({ messages, onRefresh }) {
  const close = async (id) => {
    await closeMessage(id);
    onRefresh();
  };

  // ✅ force messages to always be an array
  const safeMessages = Array.isArray(messages) ? messages : [];

  return (
    <div>
      <h2>Active Messages</h2>

      {safeMessages.length === 0 ? (
        <p>No active messages</p>
      ) : (
        safeMessages.map((m) => (
          <div
            key={m?.id}
            style={{
              border: "1px solid #ccc",
              margin: 10,
              padding: 10,
            }}
          >
            <h3>{m?.title}</h3>
            <p>{m?.message}</p>
            <small>Type: {m?.type}</small>

            <br />

            <button onClick={() => close(m?.id)}>Close</button>
          </div>
        ))
      )}
    </div>
  );
}
